import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";

export interface PageContext {
  route: string;
  params: Record<string, string>;
}

/** Pure helper (node-env testable): route + defined params only. */
export function buildPageContext(
  pathname: string,
  params: Record<string, string | undefined>,
): PageContext {
  const filtered: Record<string, string> = {};
  for (const [key, value] of Object.entries(params)) {
    if (typeof value === "string") filtered[key] = value;
  }
  return { route: pathname, params: filtered };
}

/**
 * The page context the assistant panel POSTs with every message (spec §2:
 * route + entity ids) so Pilot knows what the user is looking at.
 */
export function usePageContext(): PageContext {
  const { pathname } = useLocation();
  const params = useParams();
  return useMemo(
    () => buildPageContext(pathname, params as Record<string, string | undefined>),
    [pathname, params],
  );
}
